import styled from '@emotion/styled';
import theme from '../../shared/theme';

export const Container = styled.div({
  backgroundColor: theme.colors.light,
});

export const TableContainer = styled.div({
  '& > div:first-of-type': {
    marginBottom: '3.5rem',
  },
});

export const ChartWrapper = styled.div({
});

export const HeaderContainer = styled.div({
  width: '100%',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',

  [`@media ${theme.breakpoints.above.small}`]: {
    maxWidth: 420,
  },

  '& > div': {
    width: '100%',
  },
  '& > div:first-of-type': {
    marginRight: '0.625rem',
  },
});
